<template>
    <div v-if="article" class="r-column fr br5 bgw mht-400">
        <Crumb :typeId="article.category_id"></Crumb>
        <div class="notice-detail">
            <div class="notice-title fs30 fbold tcenter pb40">
                {{ article.title }}
            </div>
            <div class="notice-cont ncont fs16 lh20" v-html="article.content">
            </div>
        </div>
    </div>
</template>
<script>
import Crumb from '@/components/common/Crumb'
import { throws } from 'assert'
export default {
    data() {
        return {
            article: [],
            typeId: 0,
        }
    },
    components: {
        Crumb
    },
    created() {
        this.initData()
    },
    methods: {
        initData() {
            this.typeId = this.$route.params.id
            this.getNewsList()
        },
        getNewsList() {
            const query = {
                category_id: this.typeId,
            }
            this.$request.get('article/list', query, res => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    let article = data.data[0]
                    article.category_id = article.category_id.toString()
                    this.article = article
                }
            }, err => {
                console.log(err)
                this.isLoad = false
            })
        },
        chagePage(page) {
            this.page = page - 1
            this.getNewsList()
        }

    }
}
</script>
<style scope>
.no-cont {
    margin-top: 80px;
}
</style>
    